/* eslint-disable no-console, no-plusplus */
export function changeFontSize() {
    // eslint-disable-next-line no-console

    const fontSizePlus = document.querySelector('.font-size-plus');
    const fontSizeMinus = document.querySelector('.font-size-minus');
    const target = document.querySelector('.content');
    // const target = document.documentElement;

    if (target) {
        // check session storage on reload
        if (window.sessionStorage.getItem('font-size') === 'large') {
            target.classList.add('content--large');
            fontSizePlus.style.display = 'none';
            fontSizeMinus.style.display = 'inline-block';
        } else {
            fontSizePlus.style.display = 'inline-block';
        }

        // increase font size
        fontSizePlus.addEventListener('click', () => {
            window.sessionStorage.setItem('font-size', 'large');
            target.classList.add('content--large');
            fontSizePlus.style.display = 'none';
            fontSizeMinus.style.display = 'inline-block';
        });

        // decrease (reset) font size
        fontSizeMinus.addEventListener('click', () => {
            window.sessionStorage.removeItem('font-size');
            target.classList.remove('content--large');
            fontSizePlus.style.display = 'inline-block';
            fontSizeMinus.style.display = 'none';
        });
    }
}
changeFontSize();

export function manageBookmark() {
    const bookmarkComponentExists = !!document.querySelector(
        '.utility-nav__my-bookmarks'
    );
    // If the module exists, do whatever we need to
    if (bookmarkComponentExists) {
        // ------------------------------------------------------------
        // Bookmarks app
        // ------------------------------------------------------------

        // Selectors
        const bookmarkBtn = document.querySelector('.share-page__bookmark');
        const bookmarkList = document.querySelector('.bookmark__list');
        const bookmarkCount = document.querySelector(
            '.utility-nav__bookmarks-count'
        );
        const bookmarkNavContainer = document.querySelector(
            '.utility-nav__my-bookmarks'
        );
        const clearAllBtn = document.querySelector(
            '.utility-nav__clear-bookmarks'
        );
        const currentPageDataEl = document.querySelector('.bookmark-info');
        const currentPageData = {
            name: currentPageDataEl.dataset.bookmarkName,
            url: currentPageDataEl.dataset.bookmarkUrl,
            id: currentPageDataEl.dataset.bookmarkId,
        };
        let removeBtnList = [];
        // Mobile selectors
        const bookmarkBtnMobile = document.querySelector(
            '.hamburger-landmark__bookmark-heart'
        );
        const bookmarkDropdownContainer = document.querySelector(
            '.bookmark__dropdown'
        );
        const bookmarkBtnClose = document.querySelector(
            '.bookmark__btn--close'
        );

        // Helpers
        const checkLocalStorage = function () {
            return JSON.parse(localStorage.getItem('sscBookmarks'));
        };

        const toggleBookmarkNav = function () {
            bookmarkNavContainer.classList.toggle('my-bookmarks--hide');
        };

        const addToLocalStorage = function (item) {
            localStorage.setItem('sscBookmarks', JSON.stringify(item));
        };

        const renderMarkup = function (bookmarkItem) {
            // 1. create markup for the bookmark
            const markup = `<div class="utility-nav__bookmark-link"><a href="${bookmarkItem.url}">${bookmarkItem.name}</a><span class="remove-bookmark bookmark__delete" data-id="${bookmarkItem.id}">Remove</span></div>`;

            // 2. append the markup to the bookmark list
            bookmarkList.insertAdjacentHTML('beforeend', markup);
        };

        const countBookmarks = function () {
            const bookmarkData = checkLocalStorage();
            if (bookmarkData.length > 0) {
                bookmarkCount.innerHTML = bookmarkData.length;
            } else if (Array.isArray(bookmarkData)) {
                bookmarkCount.innerHTML = 0;
                toggleBookmarkNav();
            }
        };

        const toggleMobileBtn = function () {
            bookmarkBtnMobile.classList.toggle('bookmark-heart--active');
        };

        // App functionality
        const activateBookmarkBtn = function () {
            bookmarkBtn.classList.add('bookmark--active');
            const btnText = bookmarkBtn.querySelector(
                '.share-page__bookmark-text'
            );
            btnText.innerText = 'Added to Bookmarks';
        };

        const deactivateBookmarkBtn = function () {
            bookmarkBtn.classList.remove('bookmark--active');
            const btnText = bookmarkBtn.querySelector(
                '.share-page__bookmark-text'
            );
            btnText.innerText = 'Bookmark to this device';
        };

        const removeBookmark = function (e) {
            const bookmarkData = checkLocalStorage();
            const btn = e.target.closest('.bookmark__delete');
            const { id } = btn.dataset;

            // 1. remove the bookmark from the UI
            btn.parentElement.remove();

            // 2. remove the bookmark from the local storage
            // Create a new array of bookmarks without the one we removed
            const filterBookmarks = bookmarkData.filter((bookmark) => {
                return bookmark.id !== id;
            });

            // Clear local storage to add new bookmarks array
            localStorage.removeItem('sscBookmarks');
            addToLocalStorage(filterBookmarks);

            // 3. Remove the active state on button if bookmark is this page
            if (id === currentPageData.id) {
                deactivateBookmarkBtn();
            }

            // 4. display number of bookmarks or hide the dropdown if there are no bookmarks
            countBookmarks();

            // 5. Toggle state of mobile bookmark button
            toggleMobileBtn();
        };

        const generateBtnList = function () {
            removeBtnList = document.querySelectorAll('.bookmark__delete');
            removeBtnList.forEach((removeBtn) => {
                removeBtn.addEventListener('click', removeBookmark);
            });
        };

        const createBookmark = function () {
            const bookmarkData = checkLocalStorage();

            activateBookmarkBtn();

            // add to local storage
            if (bookmarkData) {
                bookmarkData.push(currentPageData);
                addToLocalStorage(bookmarkData);
                renderMarkup(currentPageData);
                countBookmarks();
                bookmarkNavContainer.classList.remove('my-bookmarks--hide');
                generateBtnList();
                toggleMobileBtn();
            } else {
                addToLocalStorage([currentPageData]);

                toggleBookmarkNav();
                renderMarkup(currentPageData);
                countBookmarks();
                generateBtnList();
                toggleMobileBtn();
            }
        };

        const clearAllBookmarks = function () {
            // 1. Remove the active state on bookmark button
            deactivateBookmarkBtn();

            // 2. clear local storage
            localStorage.removeItem('sscBookmarks');

            // 3. Hide the bookmark nav
            toggleBookmarkNav();

            // 4. Remove all bookmarks from the UI
            bookmarkList.innerHTML = '';

            // 5. Toggle state of mobile bookmark button
            toggleMobileBtn();
        };

        const startBookmark = function () {
            const bookmarkData = checkLocalStorage();

            // check if the page is already bookmarked, if so, remove bookmark
            if (bookmarkData && bookmarkData.length > 0) {
                const bookmarkIsCurrentPage = bookmarkData.find((bookmark) => {
                    return bookmark.id === currentPageData.id;
                });

                if (bookmarkIsCurrentPage) {
                    console.log('already bookmarked');
                    removeBtnList =
                        document.querySelectorAll('.bookmark__delete');
                    const removeBtnArr = Array.from(removeBtnList);
                    const removeBtn = removeBtnArr.find((bookmark) => {
                        return bookmark.dataset.id === currentPageData.id;
                    });

                    removeBtn.click();
                } else {
                    // check if the page is not bookmarked, create bookmark
                    createBookmark();
                }
            } else {
                // check if the page is not bookmarked, create bookmark
                createBookmark();
            }
        };

        const init = function () {
            // 1. check if there is any bookmarks in localStorage
            const bookmarkData = checkLocalStorage();

            // 2. if there is any bookmarks, show the nav, and render them
            if (bookmarkData && bookmarkData.length > 0) {
                toggleBookmarkNav();
                bookmarkData.forEach((bookmark) => {
                    renderMarkup(bookmark);
                });
                countBookmarks();
                toggleMobileBtn();

                // 2.1 is the current page bookmarked?
                const isBookmarked = bookmarkData.find(
                    (bookmark) => bookmark.id === currentPageData.id
                );
                if (isBookmarked) {
                    activateBookmarkBtn();
                }
            }
        };

        // Event listeners
        init();
        bookmarkBtn.addEventListener('click', startBookmark);
        clearAllBtn.addEventListener('click', clearAllBookmarks);
        generateBtnList();
        // Mobile display
        [bookmarkBtnMobile, bookmarkBtnClose].forEach((btn) => {
            btn.addEventListener('click', () => {
                bookmarkDropdownContainer.classList.toggle(
                    'bookmark__dropdown--active'
                );
            });
        });
    }
}
manageBookmark();
